module.exports = new Promise(resolve => {
    const script = document.createElement('script')
    script.src = window.mainUrls['APIManager']
    if (!script.src) {
      resolve({
        get: (request) => { throw new Error('Module APIManager URL not available') },
        init: (arg) => { throw new Error('Module APIManager URL not available') }
      })
      return
    }
    script.onload = () => resolve({
      get: (request) => window['APIManager'].get(request),
      init: (arg) => {
        try {
          return window['APIManager'].init(arg)
        } catch(e) {
          console.warn('remote container already initialized: APIManager')
        }
      }
    })
    script.onerror = () => resolve({
      get: (request) => { throw new Error('Module APIManager not available') },
      init: (arg) => { throw new Error('Module APIManager not available') }
    })
    document.head.appendChild(script);
  });